module.exports = __webpack_public_path__ + "static/media/skunk.e9ae26cc.png";